import { COUNTRY_PUBLIC_LINK } from '@/constants/country';
import { Language } from '@/constants/currencyConfig';
import { CS_LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { Locale } from '@/types/locale';
import { createLink } from '@/utils/links';
import type { Roots } from 'next-roots/context';

import { Router } from 'next/router';

export type CurrentPage = keyof typeof CS_LINKS;

function getUnprefixedPath(path: string, locale: string): string {
	const result = path.replace(`/${locale}/`, '');

	// If the path is the same as the original, it means that the path does not contain the locale
	if (result === path) {
		return '/';
	}

	return result;
}

export function useHreflangs(
	roots: Roots,
	router: Router
): Array<{
	hrefLang: Locale;
	href: string;
}> {
	const locales = roots.locales as Language[];
	const query = router.query;

	return locales
		.filter((locale) => locale !== roots.currentLocale)
		.map((locale) => {
			const matchedMeta = roots.meta.find((m) => m.key === `${locale}:${roots.currentRoot}`);

			if (!matchedMeta) {
				return null;
			}

			const hrefLang = locale;
			const rule = roots.rules.find((r) => r.key === matchedMeta.key);

			if (!rule) {
				return null;
			}

			const unprefixedPath = getUnprefixedPath(rule.href, locale);

			if (!isAllowedRoute(unprefixedPath, locale)) {
				return null;
			}

			const href = createLink({
				base: COUNTRY_PUBLIC_LINK[locale],
				pathname: unprefixedPath,
				query,
			});

			return { hrefLang, href };
		})
		.filter(Boolean);
}
